var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { filter } from 'rxjs/operators';
var DynamicTextArea = /** @class */ (function (_super) {
    __extends(DynamicTextArea, _super);
    function DynamicTextArea(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null,
            validateStatus: null,
            help: null
        };
        return _this;
    }
    DynamicTextArea.prototype.componentDidMount = function () {
        var _this = this;
        this.refreshValue();
        this.props.dataState.pathChange
            .pipe(filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            validateStatus: null,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            validateStatus: 'error',
            help: JSON.stringify(error.constraints)
        }); });
    };
    DynamicTextArea.prototype.setValue = function (value) {
        this.setState({
            value: value
        });
        this.props.dataState.set(this.props.control.path, value, {
            sender: this
        });
    };
    DynamicTextArea.prototype.refreshValue = function () {
        this.setState({
            value: this.props.dataState.get(this.props.control.path)
        });
    };
    DynamicTextArea.prototype.render = function () {
        return React.createElement("div", null, "NONE");
    };
    return DynamicTextArea;
}(React.Component));
export default DynamicTextArea;
//# sourceMappingURL=Textarea.js.map